module.exports = __webpack_public_path__ + "img/02.8c06ce78.png";